// src/config/axiosConfig.js
import axios from 'axios';

// Criar instância do axios com baseURL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api-cartao.askbox.com.br'
});

// Configurar interceptor global
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export default axiosInstance;